export default function TheStudiosSoul() {
  return <></>;
}